export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/envelope.2acc55f7.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};